var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blog-detail-container"},[_c('h1',[_vm._v(_vm._s(_vm.blog.title))]),_c('div',{staticClass:"aside"},[_c('span',[_vm._v("日期："+_vm._s(_vm.formatDate(_vm.blog.createDate)))]),_c('span',[_vm._v("浏览："+_vm._s(_vm.blog.scanNumber))]),_c('a',{attrs:{"href":"#data-form-conteiner"}},[_vm._v("评论："+_vm._s(_vm.blog.commentNumber))]),_c('RouterLink',{attrs:{"to":{
            name:'CategoryBlog',
            params:{
                categoryId:_vm.blog.category.id
            }
        }}},[_vm._v(_vm._s(_vm.blog.category.name))])],1),_c('div',{domProps:{"innerHTML":_vm._s(_vm.blog.htmlContent)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }